export const teamConstants = {
  TEAM_SUCCESS: 'TEAM_SUCCESS',
  TEAM_FAILURE: 'TEAM_FAILURE',
};
